import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Form, Select, CustomInlineViewFilters, Button } from '../../../../components';
import { queryParamMappings, APP_OPTIONS } from '../../../../config/constants';

import './style.scss';

const ViewFilterElementCustom = (props) => {
  const { filter, onChange, defaultValues } = props;
  const options = [];
  let defaultValue = null;

  if (typeof filter === 'undefined') {
    return (
      <div className="filter-item">
        Filter undefined
      </div>
    );
  }

  const filtersToInclude = ['field_department_target_id', 'field_address_target_id', 'field_thinking_working_level_target_id'];

  if (
    filter.get('field') !== 'title'
    && !filtersToInclude.includes(filter.get('field'))
  ) {
    return null;
  }

  switch (filter.get('plugin_id')) {
    case 'entity_reference_tree_inline_filter':
      filter.get('options').map((option) => {
        options.push({ value: option.get('label'), label: option.get('label') });
      });

      if (defaultValues[filter.get('field')]) {
        defaultValue = { value: defaultValues[filter.get('field')].value, label: `${defaultValues[filter.get('field')].value}` };
      }

      return (
        <div className="form-item" key={filter.get('field')} id={`form-item-${filter.get('field')}`}>
          <label htmlFor={filter.get('field')}>{filter.getIn(['expose', 'label'])}</label>
          <Select
            name={filter.get('field')}
            id={filter.get('field')}
            handleChange={(option) => onChange(filter.get('field'), { value: option.value })}
            options={options}
            placeholder={filter.getIn(['expose', 'placeholder'])}
            defaultValue={defaultValue}
          />
        </div>
      );

    case 'string':
      defaultValue = defaultValues[filter.get('field')] || '';

      return (
        <div className="form-item" key={filter.get('field')} id={`form-item-${filter.get('field')}`}>
          <label htmlFor={filter.get('field')}>{filter.getIn(['expose', 'label'])}</label>
          <input
            type="text"
            name={filter.get('field')}
            id={filter.get('field')}
            placeholder={filter.getIn(['expose', 'placeholder'])}
            value={defaultValue}
            onChange={(e) => onChange(filter.get('field'), e.target.value)}
          />
        </div>
      );

    default:
      return (
        <div className="filter-item">
          Filter Element: {filter.get('plugin_id')}
        </div>
      );
  }
};

const FrontpageFilters = ({ entities, ...restProps }) => {
  // eslint-disable-next-line no-unused-vars
  const [filters, setFilters] = useState([]);
  const { t } = useTranslation();
  const history = useHistory();

  const updateFilter = (field, value) => {
    setFilters({
      ...filters,
      [field]: value,
    });
    restProps.filters = filters;
  };

  const submitFilters = (e) => {
    const filters = Object.fromEntries(new FormData(e.target).entries());

    Object.entries(filters).forEach(([key, value]) => {
      const mappedKey = queryParamMappings[key];

      if (mappedKey) {
        filters[mappedKey] = value;

        delete filters[key];
      }
    });

    // put the searchcritera in a array
    const searchCriteria = [
      filters.title !== '' ? `${APP_OPTIONS.parameters.searchkitIndexVacancies}%5Bquery%5D=${encodeURIComponent(filters.title)}` : '',
      filters.department !== '' ? `${APP_OPTIONS.parameters.searchkitIndexVacancies}%5BrefinementList%5D%5Bdepartment%5D%5B0%5D=${encodeURIComponent(filters.department)}` : '',
      filters.area !== '' ? `${APP_OPTIONS.parameters.searchkitIndexVacancies}%5BrefinementList%5D%5Baddress%5D%5B0%5D=${encodeURIComponent(filters.area)}` : '',
    ];
    // filter out empty strings and join the array with an ampersand
    const concatenatedSearchCriteria = searchCriteria.filter((criteria) => criteria !== '').join('&');

    history.push({
      pathname: '/vacatures',
      search: `?${concatenatedSearchCriteria}`,
    });
  };

  return (
    <div className="FrontpageFilters">
      <Form onSubmit={(e) => { e.preventDefault(); submitFilters(e); }}>
        <CustomInlineViewFilters
          viewId="vacancies"
          display="block_2"
          onFilterUpdate={(field, value) => updateFilter(field, value)}
          // eslint-disable-next-line react/no-unstable-nested-components
          onRender={(props) => {
            return (
              <div>
                <ViewFilterElementCustom {...props} defaultValues={filters} />
                {props.filter.get('id') === 'title' && (
                  <Button id="form-field-submit" htmlType="submit" type="primary">
                    {t('search_button')}
                  </Button>
                )}
              </div>
            );
          }}
        />
      </Form>
    </div>
  );
};

export default FrontpageFilters;
